import { DialogActions, DialogContent, DialogContentText } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Typography from "@mui/material/Typography";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { baseStyledPaperSX } from "styled/styledSXProperties/styledPaperSX";

import { openAuthCheckDialog } from "../../../../redux/actions/attachmentActions";
import { setShowRequisitionDialogue } from "../../../../redux/actions/generalActions";

export default function AuthCheckDialog() {
    const dispatch = useDispatch();

    const showAuthAttachmentDialog = useSelector(
        (state) => state.attachment.showAuthAttachmentDialog
    );
    const darkMode = useSelector((state) => state.general.darkMode);

    const handleContinue = () => {
        dispatch(openAuthCheckDialog(false));
        dispatch(setShowRequisitionDialogue(true));
    };

    const handleCancle = () => {
        dispatch(openAuthCheckDialog(false));
    };

    return (
        <Dialog
            onClose={handleCancle}
            open={showAuthAttachmentDialog}
            data-testid="auth-check-modal"
            PaperProps={{ sx: baseStyledPaperSX(darkMode) }}
        >
            <DialogContent>
                <Typography
                    variant="h3"
                    marginBottom={"4px"}
                    data-testid="auth-check-title"
                >
                    Authorisation
                </Typography>
                <DialogContentText
                    id="alert-dialog-description"
                    variant="body1"
                    data-testid="auth-check-body"
                >
                    You are not authorised to copy attachments from this
                    requisition.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button
                    variant="contained"
                    onClick={handleCancle}
                    sx={{ margin: "0px 10px" }}
                >
                    Cancel
                </Button>
                <Button variant="contained" onClick={handleContinue}>
                    Continue
                </Button>
            </DialogActions>
        </Dialog>
    );
}
